"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var view_models_1 = require("./../view-models");
var CardIFrameService = (function () {
    function CardIFrameService() {
    }
    CardIFrameService.prototype.buildCardIFrameURL = function (paymentFormData) {
        var queryParams = '?';
        var billingFormInfo = this.mapBillingInformation(paymentFormData);
        // if there's no state provided, they might make it through payment without providing a state,
        // which breaks purchase and is bad in general, so force them to enter a billing address
        // also email address is required for disbursement but not enforced correctly on Simplify's side so do this hack
        if (billingFormInfo.stateOrProvince && billingFormInfo.email) {
            queryParams += 'address=' + encodeURIComponent(this.valOrEmptyString(billingFormInfo.address1));
            queryParams += '&state=' + encodeURIComponent(this.valOrEmptyString(billingFormInfo.stateOrProvince));
        }
        else {
            queryParams += 'address=';
        }
        queryParams += '&city=' + encodeURIComponent(this.valOrEmptyString(billingFormInfo.city));
        queryParams += '&zip=' + encodeURIComponent(this.valOrEmptyString(billingFormInfo.postalCode));
        queryParams += '&email=' + encodeURIComponent(billingFormInfo.email);
        queryParams += '&name=' + encodeURIComponent(this.valOrEmptyString(billingFormInfo.name));
        queryParams += '&buttonText=' + encodeURIComponent(paymentFormData.buttonText);
        if (paymentFormData.enableMasterPass) {
            queryParams += '&enableMasterPass=true';
        }
        if (paymentFormData.forDisbursements) {
            queryParams += '&saveTokenForDisbursements=true';
        }
        var url = paymentFormData.baseUrl + 'iframe/bhtp' + queryParams;
        return url;
    };
    CardIFrameService.prototype.mapBillingInformation = function (paymentFormData) {
        var address = new view_models_1.BillingFormInfo();
        // Use the address if it exists
        if (paymentFormData.address) {
            address.address1 = paymentFormData.address.address1;
            address.city = paymentFormData.address.city;
            address.stateOrProvince = paymentFormData.address.stateOrProvince;
            address.postalCode = paymentFormData.address.postalCode;
            address.email = paymentFormData.emailAddress;
            if (paymentFormData.primaryTravelerName) {
                address.name = this.valOrEmptyString(paymentFormData.primaryTravelerName);
            }
            else {
                address.name = this.valOrEmptyString(paymentFormData.firstName) + ' ' + this.valOrEmptyString(paymentFormData.lastName);
            }
        }
        else {
            // Use billing address if there is no primary address
            address.address1 = paymentFormData.billing.address1;
            if (address.address1 && paymentFormData.billing.address2) {
                address.address1 = address.address1 + ' ' + paymentFormData.billing.address2;
            }
            address.city = paymentFormData.billing.city;
            address.stateOrProvince = paymentFormData.billing.stateOrProvince;
            address.postalCode = paymentFormData.billing.postalCode;
            address.email = paymentFormData.billing.email;
            address.name = paymentFormData.billing.name;
        }
        if (paymentFormData.billing) {
            address.customerId = paymentFormData.billing.customerId;
        }
        return address;
    };
    CardIFrameService.prototype.valOrEmptyString = function (val) {
        return val || '';
    };
    return CardIFrameService;
}());
CardIFrameService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], CardIFrameService);
exports.CardIFrameService = CardIFrameService;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/payments/card-iframe.service.js